import { StyleRules, TableRowClassKey } from "@material-ui/core";
import { Shades } from "style/Colors";

export const MuiTableRow: Partial<StyleRules<TableRowClassKey, {}>> = {
  root: {
    backgroundColor: Shades.gray10,
    fontSize: 16,
  },
};
